import type { FC } from "react";
import type { MatchLineupComponent } from "@motain/xpa-proto-files-web/lib/types/match_lineup";
import { isNonNullable } from "@/types/isNonNullable";
import classNames from "classnames";
import styles from "./MatchLineupWrapper.module.scss";
import { MatchLineupEmptyState } from "./match-lineup-empty-state/MatchLineupEmptyState";
import { MatchLineup } from "./match-lineup/MatchLineup";

export const MatchLineupWrapper: FC<MatchLineupComponent> = (props) => {
  const { title, variant } = props;

  return (
    <section className={styles.container}>
      {isNonNullable(title) && title !== "" && (
        <header className={classNames("title-7-bold", styles.header)}>
          {title}
        </header>
      )}
      {variant?.$case === "empty" && (
        <MatchLineupEmptyState {...variant.empty} />
      )}

      {variant?.$case === "lineup" && <MatchLineup {...variant.lineup} />}
    </section>
  );
};
